module.exports = __webpack_public_path__ + "img/feel-good-fourth.ad18c218.png";